import { ApplicantType } from "shared/types";

export const getApplicantRole = (
  role?: ApplicantType | null,
  isPrimaryApplicant?: boolean
) => {
  if (role === ApplicantType.Occupant) return "Occupant";

  if (role === ApplicantType.CoSigner) return "Guarantor";

  if (role === ApplicantType.Applicant) {
    if (isPrimaryApplicant === true) return "Primary applicant";
    if (isPrimaryApplicant === false) return "Co-applicant";
    return "Applicant";
  }

  return "-";
};
